import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import { CheckCircle, XCircle, BellOff } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Confirmation (/suivi/confirmer) et désabonnement (/suivi/desabonnement)
// du suivi de chantier par email — liens reçus par email.
export default function FollowConfirm() {
  const [params] = useSearchParams();
  const location = useLocation();
  const isUnsubscribe = location.pathname.includes('desabonnement');
  const token = params.get('token');
  const [state, setState] = useState('pending'); // pending | ok | error
  const [message, setMessage] = useState('');
  const requested = useRef(false);

  useEffect(() => {
    if (!token) { setState('error'); return; }
    if (requested.current) return;
    requested.current = true;
    const endpoint = isUnsubscribe ? 'unsubscribe' : 'confirm';
    axios.post(`${API_URL}/public/follow/${endpoint}`, { token })
      .then(({ data }) => { setMessage(data.message); setState('ok'); })
      .catch(() => setState('error'));
  }, [token, isUnsubscribe]);

  return (
    <div className="auth-page">
      <div className="auth-card card" style={{ textAlign: 'center' }}>
        {state === 'pending' && <p>Un instant...</p>}
        {state === 'ok' && (
          <>
            {isUnsubscribe
              ? <BellOff size={44} color="#64748b" style={{ margin: '0 auto 14px' }} />
              : <CheckCircle size={44} color="#16a34a" style={{ margin: '0 auto 14px' }} />}
            <h2 style={{ marginBottom: 10 }}>{isUnsubscribe ? 'Désabonnement effectué' : 'Suivi confirmé'}</h2>
            <p style={{ color: 'var(--text-light)', lineHeight: 1.6 }}>{message}</p>
          </>
        )}
        {state === 'error' && (
          <>
            <XCircle size={44} color="#dc2626" style={{ margin: '0 auto 14px' }} />
            <h2 style={{ marginBottom: 10 }}>Lien invalide</h2>
            <p style={{ color: 'var(--text-light)' }}>Ce lien n'est plus valable.</p>
          </>
        )}
      </div>
    </div>
  );
}
